import { EDeviceActions } from '../../store/deviceStore/DeviceStoreTypes'

export const devicesFr = {
    actions: {
        deleteDevice: "Supprimer l'appareil",
        deleteDeviceName: "Nom de l'appareil",
        deleteDeviceNameConfirm: "Nom de l'appareil pour confirmer",
        addDetection: {
            action: 'Détection manuelle',
            title: 'Ajouter une détection manuellement',
            timestamp: 'Temps de passage',
            createDetectionSuccess: 'Détection crée avec succès !'
        },
        reassignCheckpoint: 'Affecter à un checkpoint',
        attachDeviceToOrganization: 'Attacher à un client',
        detachDeviceToOrganization: 'Détacher du client',
        changeDeviceType: "Change de type d'appareil",
        commands: {
            arguments: 'Arguments',
            availableCommands: 'Commandes disponibles',
            commandConfig: 'Arguments de la commande {command}',
            commandTitle: 'Envoyer une commande',
            createdAt: 'Crée le',
            from: 'Par',
            historyText: 'Historique des commandes',
            lastUpdate: 'Dernière mise à jour',
            noAvailableCommand: 'Aucune commande disponible',
            sendCommand: 'Envoyer la commande {command}'
        },
        rdrChannels: {
            rdrChannelsText:
                'Le channel RFID de cet appareil est déjà en utilisation sur ce checkpoint. Souhaitez-vous également affecter un autre channel à cet appareil ?'
        }
    },
    api: {
        error: {
            [EDeviceActions.CREATE_DEVICE]: "Erreur lors de la création de l'appareil {name} ",
            [EDeviceActions.DELETE_DEVICE]: "Erreur lors de la suppression de l'appareil {name} ",
            [EDeviceActions.FETCH_DEVICE]: "Erreur lors de la récupération de l'appareil",
            [EDeviceActions.FETCH_DEVICES]: 'Erreur lors de la récupération des appareils',
            [EDeviceActions.UPDATE_DEVICE]: "Erreur lors de la modification de l'appareil {name}",

            [EDeviceActions.MASS_UPDATE_DEVICE]:
                'Erreur lors de la mise à jour de tous les appareils',
            [EDeviceActions.FETCH_API_DEVICE]: "Erreur lors de la récupération de l'appareil",
            [EDeviceActions.UPDATE_API_DEVICE]: "Erreur lors de la mise à jour de l'appareil",
            [EDeviceActions.GET_DEVICE_API_KEY]: 'Erreur lors de la récupération de clé API',
            [EDeviceActions.GET_COMMANDS]: 'Erreur lors de la récupération des commandes',
            [EDeviceActions.GET_DEVICE_COMMANDS_HISTORY]:
                "Erreur lors de la récupération de l'historique des commandes",
            [EDeviceActions.SEND_DEVICE_COMMAND]: "Erreur lors de l'envoi de la commande",
            [EDeviceActions.REINITIALIZE_DEVICE_FLAG]:
                "Erreur lors de la réinitialisation du flag d'identification",
            [EDeviceActions.CHANGE_SERIAL_NUMBER]: 'Erreur lors du changement de numéro de série'
        },
        success: {
            [EDeviceActions.CREATE_DEVICE]: "Création de l'appareil {name} effectuée avec succès !",
            [EDeviceActions.DELETE_DEVICE]:
                "Suppression de l'appareil {name} effectuée avec succès !",
            [EDeviceActions.FETCH_DEVICE]: "Récupération de l'appareil effectuée avec succès !",
            [EDeviceActions.FETCH_DEVICES]: 'Récupération des appareils effectuée avec succès !',
            [EDeviceActions.UPDATE_DEVICE]:
                "Modification(s) de l'appareil {name} effectuée(s) avec succès !",

            [EDeviceActions.MASS_UPDATE_DEVICE]:
                'Mise à jour des appareils effectuée avec succès !',
            [EDeviceActions.FETCH_API_DEVICE]: "Récupération de l'appareil effectuée avec succès !",
            [EDeviceActions.UPDATE_API_DEVICE]: "Mise à jour de l'appareil effectuée avec succès !",
            [EDeviceActions.GET_DEVICE_API_KEY]:
                "Récupération de la clé d'API effectuée avec succès !",
            [EDeviceActions.GET_COMMANDS]: 'Récupération des commandes effectuée avec succès !',
            [EDeviceActions.GET_DEVICE_COMMANDS_HISTORY]:
                "Récupération de l'historique des commandes effectuée avec succès !",
            [EDeviceActions.SEND_DEVICE_COMMAND]: 'Envoi de la commande effectué avec succès !',
            [EDeviceActions.REINITIALIZE_DEVICE_FLAG]:
                "Réinitialisation du flag d'identification effectuée avec succès !",
            [EDeviceActions.CHANGE_SERIAL_NUMBER]:
                'Changement du numéro de série effectué avec succès !'
        }
    },
    buttons: {
        hideAdvanced: 'Cacher la configuration avancée',
        showAdvanced: 'Montrer la configuration avancée'
    },
    configuration: {
        errors: {
            rangeError: 'La valeur doit être comprise entre {min} et {max}',
            excludedError: 'La valeur ne peut pas être {excluded}'
        },

        name: "Nom de l'appareil",

        unknownKey: 'Clé inconnue',
        undefinedDescription: 'Description non définie',

        hasModificationsContent: 'La configuration contient les modifications suivantes :',
        hasModificationsConfirmation: 'Souhaitez-vous vraiment les sauvegarder ?',
        hasErrorContent: 'Ces champs contiennent des erreurs :',
        hasErrorConfirmation: "Veuillez corriger les erreurs avant d'enregistrer"
    },
    createDevice: 'Créer un appareil',
    detail: {
        informations: {
            actions: 'Actions',
            informationsTitle: 'Informations',
            latestDetections: 'Détections',
            localization: 'Localisation',
            config: 'Configuration'
        },
        configuration: {
            configurationTitle: 'Configuration',
            connectivityTitle: 'Connexion',
            miscTitle: 'Autres'
        },
        detections: {
            detectionsTitle: 'Détections',
            table: {
                bib: 'Bib',
                checkpoint: 'Checkpoint',
                timestamp: 'Date',
                device: 'Appareil',
                event: 'Evènement',
                event_filter: 'Event filter',
                timer_filter: 'Timer filter'
            },
            liveDetections: 'Détections en direct',
            pastDetections: 'Détections précédentes'
        },
        documents: {
            documentsTitle: 'Documents'
        },
        history: {
            historyTitle: 'Historique de configuration',
            filters: {
                name: 'Nom de la clé'
            }
        },
        informationsTitle: 'Informations'
    },
    filters: {
        checkpoint: 'Checkpoint',
        event: 'Évènement',
        isRented: 'En location',
        lowBattery: 'Batterie faible',
        lowSignal: 'Signal faible',
        name: 'Nom',
        nameOrSerial: 'Nom ou numéro de série'
    },
    latestDetections: 'Détections',
    model: {
        apiKey: "Clé d'API",
        checkpointName: 'Checkpoint associé',
        description: 'Description',
        deviceName: "Nom de l'appareil",
        deviceType: "Type d'appareil",
        eventName: 'Evènement associé',
        firmwareUpdated: 'Dernière mise à jour du firmware',
        firmwareVersion: 'Version du firmware',
        imeiSAT: 'Imei SAT',
        lastMaintenanceDate: "Dernière date d'entretien",
        manufactureDate: 'Date de fabrication',
        organizationName: 'Propriétaire',
        serialNumber: 'Numéro de série',
        simIccid: 'Sim ICCID',

        config_status: 'Configuration en attente de synchronisation',
        config_synced_at: 'Dernière synchronisation de la configuration'
    },
    noDetectionFound: 'Aucune détection trouvée',
    rental: {
        rentalApiSuccess: 'Location crée avec succès !',
        rentalApiError: 'Erreur lors de la création de la location',
        action: "Louer l'appareil",
        title: "Louer l'appareil à une autre organisation",
        renterName: 'Loué à',
        rentedByEmail: 'Propriétaire',
        rentToOrganization: 'Organisation choisie',
        startAt: 'Début de la location',
        endAt: 'Fin de la location',
        rented: 'En location',
        unavailable: 'Indisponible',
        incomingRentals: 'Locations à venir',

        updateCurrentRentalAction: 'Modifier la location',
        updateCurrentRentalTitle: 'Modifier la location courante',
        updateCurrentRentalDescription:
            'Souhaitez-vous vraiment modifier la location courante ? Cette action est irréversible.',
        updateRentalApiSuccess: 'Location modifiée !',

        endCurrentRentalAction: 'Terminer la location',
        endCurrentRentalTitle: 'Terminer la location courante',
        endCurrentRentalDescription:
            "Souhaitez-vous vraiment terminer la location courante ? Cette action retirera les accès de l'appareil au locataire.",
        endRentalApiSuccess: 'Location terminée !'
    },
    rentalsHistory: {
        title: 'Historique des locations',
        table: {
            rental_end_at: 'Fin',
            rental_start_at: 'Début',
            renter: 'Locataire'
        }
    },
    status: {
        online: 'En ligne',
        offline: 'Hors ligne',
        lowBattery: 'Batterie faible',
        lowSignal: 'Signal moyen',
        warning: 'A surveiller',

        lastBatteryLevel: 'Dernier niveau de batterie connu : {battery}',
        lastBatteryLevelUnknown: 'Dernier niveau de batterie inconnu',
        updateAvailable: 'Mise à jour disponible'
    },
    table: {
        alerts: 'Alertes',
        createDevice: 'Créer un appareil',
        deviceType: "Type d'appareil",
        name: 'Nom',
        currentEventTitle: 'Evènement associé'
    },
    title: {
        checkpointTitle: 'Checkpoint',
        eventTitle: 'Évènement',
        checkpointAssociatedTitle: 'Checkpoint associé',
        currentEventTitle: 'Evènement associé',
        noEventAssociated: 'Aucun évènement associé'
    },

    reinitializeFlag: {
        buttonTitle: 'Réinitialiser flag',
        dialogTitle: "Réinitialiser flag d'identification",
        dialogContent:
            "Souhaitez-vous vraiment réinitialiser le flag d'identification de l'appareil ?"
    },
    changeSerialNumber: {
        buttonTitle: 'Remplacer numéro de série',
        dialogTitle: 'Remplacer le numéro de série',
        dialogContent: "Nouveau numéro de série de l'appareil"
    },
    updateVersion: {
        buttonTitle: 'Mise à jour',
        updateTitle: "Mettre à jour la version de l'appareil",

        cancelStep: 'Annuler',
        previousStep: 'Précédent',
        nextStep: 'Suivant',
        updateStep: 'Mettre à jour maintenant',

        stepOne: {
            title: "Mise à jour d'équipement :",
            firstLine: "Vous débutez le process de mise à jour d'un équipement.",
            secondLine: 'Nous recommandons les précautions suivantes :',

            firstRule: "L'équipement est connecté",
            secondRule: "L'équipement est à votre disposition (non loué) et à portée de main",
            thirdRule: 'Ce dernier est chargé à plus de 50%',
            fourthRule:
                "Nous déconseillons la mise à jour d'un équipement pendant son utilisation sur un évènement",
            fifthRule: 'Ne pas retirer la batterie pendant la mise à jour'
        },

        stepTwo: {
            title: 'Mise à jour {name} :',
            battery: 'Batterie {battery}%',
            notAffected: 'Non rattaché à un évènement',
            notRented: 'Non loué',

            versionSelection: 'Version à appliquer :',
            version: 'Version {version}',
            priority: '(Version à installer prioritairement)'
        }
    },

    versionHistory: {
        title: 'Historique des versions',

        table: {
            lastVersion: 'Version précédente',
            sentVersion: 'Version envoyée',
            sentDate: "Date d'envoi",
            user: 'Utilisateur',
            progress: 'Avancement'
        }
    }
}
